module.exports = __webpack_public_path__ + "img/card-compare-two-image-2.b851b542.png";